import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ButtonGroup from '../../components/button-group';
import UserAvatarImage from '../../components/user-avatar-image';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './member-confirmation.scss';

const MemberConfirmation = ({ user, children, confirm, onConfirm, cancel, onCancel, contentFontClassName }) => {
  return (
    <div className={classNames(styles.container, contentFontClassName, 'forum-text-color')}>
      <div className={styles.avatar}>
        <UserAvatarImage type="promote" user={user}/>
      </div>
      {children &&
        <div className={styles.content}>
          {children}
        </div>}
      <ButtonGroup
        primaryButtonText={confirm}
        primaryButtonProps={{ onClick: () => onConfirm() }}
        secondaryButtonText={cancel}
        secondaryButtonProps={{ onClick: () => onCancel() }}
      />
    </div>
  );
};

MemberConfirmation.propTypes = {
  user: PropTypes.object.isRequired,
  children: PropTypes.node,
  confirm: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancel: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  contentFontClassName: PropTypes.string,
};

export default withFontClassName(MemberConfirmation);



// WEBPACK FOOTER //
// ./app/components/member-confirmation/member-confirmation.js